import { Component, Input } from "@angular/core";
import { User, PanelMember, Discussion } from "../../../../models";

@Component({
  selector: "edit-credential-button",
  templateUrl: "./edit-credential-button.component.html",
  styleUrls: [
    "./edit-credential-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class EditCredentialButtonComponent {
  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() currentPanelMember: PanelMember;
  @Input() canModifyDiscussion: boolean;

  constructor() {}

  ngOnInit() {}
}
